import { useSelector } from 'react-redux'

import {
  getCockpitPlanningStatus,
  useManagerCockpitPlanningStatuses,
} from '../../../../model/hooks'
import { selectCockpitOffering } from '../../../../model/selectors'
import { PlanningStatusLine } from '../../../cockpitScopePanel/components/cockpitPlanningStatus/components/planningStatusLine'

import styles from './AttentionPlanningStatus.module.scss'

/** The manager cockpit's partners, on the attention header's context line: how many have a
 *  complete plan, how many signed it, and the plan quality across them. Keyed by the programme, so
 *  each switch counts the figures up afresh. */
export const ManagerAttentionPlanningStatus = () => {
  const statuses = useManagerCockpitPlanningStatuses()
  const selectedOffering = useSelector(selectCockpitOffering)
  const status = getCockpitPlanningStatus(statuses, selectedOffering)

  return (
    <span className={styles.root}>
      <span className={styles.separator} aria-hidden="true">
        &middot;
      </span>
      <PlanningStatusLine key={selectedOffering} status={status} animated />
    </span>
  )
}

ManagerAttentionPlanningStatus.displayName = 'ManagerAttentionPlanningStatus'
